module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a8-7-16769f749dc985058a326c286e97691d.jpg";